import {FC, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {ShopWrapper} from '../pages/shop/ShopWrapper'
import {VehiculesWrapper} from '../pages/vehicules/VehiculesWrapper'
import {RolesWrapper} from '../pages/roles/RolesWrapper'
import {UtilisateursWrapper} from '../pages/utilisateurs/UtilisateursWrapper'
import {CentreWrapper} from '../pages/centre/CentreWrapper'
import {GenresWrapper} from '../pages/genres/GenresWrapper'
import {CataloguesWrapper} from '../pages/catalogues/CataloguesWrapper'
import {RechercheCatalogueWrapper} from '../pages/RechercheCatalogue/RechercheCatalogueWrapper'

import {DemandesWrapper} from '../pages/demande/DemandesWrapper'
import {CourrielWrapper} from '../pages/courriel/CourrielWrapper'
import RemiseWrapper from '../pages/remise/RemiseWrapper'
import MotifRefusWrapper from '../pages/motifRefus/MotifRefusWrapper'
import SavWrapper from '../pages/sav/SavWrapper'
import {ReferentielTypePieceWrapper} from '../pages/referentielTypePiece/ReferentielTypePieceWrapper'
import {DemontageWrapper} from '../pages/demontage/DemontageWrapper'
import {DemandeDemontageWrapper} from '../pages/demandeDemontage/DemandeDemontageWrapper'
import {DemandeTransfertWrapper} from '../pages/demandeTransfert/DemandeTransfertWrapper'
import {ReferentielFournisseurPOTWrapper} from '../pages/referentielFournisseurPOT/ReferentielFournisseurPOTWrapper'
import {PiecesPotsWrapper} from '../pages/piecesPots/PiecesPotsWrapper'
import {ReseauClientWrapper} from '../pages/ReseauClient/ReseauClientWrapper'
import {DelaisTraitementWrapper} from '../pages/delaisTraitement/DelaisTraitementWrapper'
import {MesActionsWrapper} from '../pages/mesActions/MesActionsWrapper'
import TypesActionsWrapper from '../pages/typesActions/TypesActionsWrapper'
import {ModifPrixWrapper} from '../pages/modifPrix/ModifPrixWrapper'
import {DocumentationWrapper} from '../pages/documentation/DocumentationWrapper'
import {ProvenanceWrapper} from '../pages/provenance/ProvenanceWrapper'
import {EquipeWrapper} from '../pages/equipe/EquipeWrapper'
import {ArticleWrapper} from '../pages/article/ArticleWrapper'
import {FilArianeProvider} from "../contexts/FilArianeContext";
import {DepotWrapper} from '../pages/depot/DepotWrapper'
import {ServiceRattachementWrapper} from "../pages/serviceRattachement/ServiceRattachementWrapper";
import {GroupeLIBPRWrapper} from "../pages/groupeLIBPR/GroupeLIBPRWrapper";

const PrivateRoutes = () => {
  return (
    <FilArianeProvider>
      <Routes>
        <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='vente/*' element={<ShopWrapper />} />
        <Route path='vehicules/*' element={<VehiculesWrapper />} />
        <Route path='utilisateurs/*' element={<UtilisateursWrapper />} />
        <Route path='centres/*' element={<CentreWrapper />} />
        <Route path='provenances/*' element={<ProvenanceWrapper />} />
        <Route path='genres/*' element={<GenresWrapper />} />
        <Route path='roles/*' element={<RolesWrapper />} />
        <Route path='catalogues/*' element={<CataloguesWrapper />} />
        <Route path='recherche-catalogue/*' element={<RechercheCatalogueWrapper />} />
        <Route path='courriel/*' element={<CourrielWrapper />} />
        <Route path='remise/*' element={<RemiseWrapper />} />
        <Route path='demandes/*' element={<DemandesWrapper />} />
        <Route path='motif-refus/*' element={<MotifRefusWrapper />} />
        <Route path='sav/*' element={<SavWrapper />} />
        <Route path='referentiel-type-piece/*' element={<ReferentielTypePieceWrapper />} />
        <Route path='demontage/*' element={<DemontageWrapper />} />
        <Route path='demande-demontage/*' element={<DemandeDemontageWrapper />} />
        <Route path='demande-transfert/*' element={<DemandeTransfertWrapper />} />
        <Route path='referentiel-fournisseur-pot/*' element={<ReferentielFournisseurPOTWrapper />}/>
        <Route path='pieces-pots/*' element={<PiecesPotsWrapper />} />
        <Route path='reseau-client/*' element={<ReseauClientWrapper />} />
        <Route path='delais-traitement/*' element={<DelaisTraitementWrapper />} />
        <Route path='mes-actions/*' element={<MesActionsWrapper />} />
        <Route path='types-actions/*' element={<TypesActionsWrapper />} />
        <Route path='modif-prix/*' element={<ModifPrixWrapper />} />
        <Route path='documentation' element={<DocumentationWrapper />} />
        <Route path='equipes/*' element={<EquipeWrapper />} />
        <Route path='articles/*' element={<ArticleWrapper />} />
        <Route path='depots/*' element={<DepotWrapper />} />
        <Route path='service-rattachement/*' element={<ServiceRattachementWrapper />} />
        <Route path='groupe-libpr/*' element={<GroupeLIBPRWrapper />} />
        {/* Lazy Modules */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      </Routes>
    </FilArianeProvider>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
